import React from 'react';
import ButtonBase from './ButtonBase';
import classNames from 'classnames';

function ButtonOverlay(props) {
    let buttonClasses = classNames('btn-overlay', props.className);

    return <ButtonBase {...props} className={buttonClasses} />;
}

ButtonOverlay.propTypes = {
    ...ButtonBase.propTypes
};

ButtonOverlay.defaultProps = {
    ...ButtonBase.defaultProps
};

export default ButtonOverlay;
